module.exports = __webpack_public_path__ + "static/media/user.668f9ff6.svg";